import { Signal, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { map } from "rxjs";
import { AppSessionService } from "@vadmin/account/auth";
import { isVindiPaymentGateway } from "@subscription/payment-gateway";
import { ATTENDANCE_TRANSCRIPTION_SETTING, TRANSCRIPTION_MONTHLY_LIMIT_FEATURE } from "./transcription.model";

export function isTranscriptionEnabledForTenant(paymentGateway: string | null | undefined): boolean {
    return abp.setting.getBoolean(ATTENDANCE_TRANSCRIPTION_SETTING) && isVindiPaymentGateway(paymentGateway);
}

/**
 * Reactive form of {@link isTranscriptionEnabledForTenant}. `tenantInfo` is populated asynchronously
 * after bootstrap (AppSessionService.checkTrial), so reading the gate once at construction races that
 * HTTP call and hides the feature on whichever page loads win the race (consistent locally, a coin-flip
 * on staging — VS-1596). Deriving from `onTenantInfoChanged` self-corrects the moment tenant info lands.
 * Must be called in an injection context (field initializer / constructor).
 */
export function tenantTranscriptionEnabled(): Signal<boolean> {
    const session = inject(AppSessionService);
    const enabled = () => isTranscriptionEnabledForTenant(session.tenantInfo?.paymentGateway);
    return toSignal(session.onTenantInfoChanged.pipe(map(enabled)), { initialValue: enabled() });
}

export function hasTranscriptionQuota(): boolean {
    return Number(abp.features.getValue(TRANSCRIPTION_MONTHLY_LIMIT_FEATURE)) > 0;
}
